// types.js
const FETCH_TRIAL_COUNTS = 'trial/counts/fetch';
const FETCH_TRIAL_COUNTS_SUCCESS = 'trial/counts/fetch-success';
const FETCH_TRIAL_COUNTS_FAIL = 'trial/counts/fetch-fail';

export default {
  FETCH_TRIAL_COUNTS,
  FETCH_TRIAL_COUNTS_SUCCESS,
  FETCH_TRIAL_COUNTS_FAIL,
}